/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { withTranslation } from 'react-i18next';
import Paquete from './paquete';
import Preloader from '../layout/Preloader';
import './contenido.css';
import NoResultados from '../layout/no-resultados';

class Contenido extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    const { t } = this.props;
    let contenidoListado;
    if (this.props.preloader) {
      contenidoListado = <Preloader titulo={t('packages.searching')} />;
    } else if (this.props.paquetes.length > 0) {
      const isMobile = (window.innerWidth < 990);
      const { paquetes } = this.props;
      const listItems = paquetes.map((elemento, index) => (
        <LazyLoad key={index} height={isMobile ? 740 : 330} offset={100}>
          <Paquete
            cantidadPasajeros={this.props.cantidadPasajeros}
            cupos={this.props.cupos}
            distribucion={this.props.distribucion}
            salidas={elemento.salidas}
            paquete={elemento}
            indice={index}
            key={index}
          />
        </LazyLoad>
      ));
      contenidoListado = (
        <div>
          {listItems}
        </div>
      );
    } else {
      contenidoListado = <NoResultados />;
    }
    return (
      <>
        {contenidoListado}
      </>
    );
  }
}

export default (withTranslation(['layout'])(Contenido));
